import React from "react"

import Text from "../components/text/Text"
import DottedLineHorizontal from "../components/DottedLineHorizontal"
import DefaultLayout from "../layouts/default"
import { natur } from "../data/akkordeon"

const active = {
  title: "Natur als Denkraum"
}

const NaturUndIhreBedeutung = () =>
  <DefaultLayout image="/assets/images/IMG_6986.jpg" active={active}>
    <div style={{ paddingTop: 40, paddingBottom: 50 }}>
        <Text>
          <p>Im Gehen kommen Gedanken in Bewegung. Abstand, Perspektivwechsel und die Veränderung der Umgebung können dazu beitragen, Zusammenhänge klarer zu erkennen und neue Sichtweisen zu entwickeln.</p>

          <p>Neurowissenschaftliche Erkenntnisse zeigen, dass Bewegung Denk- und Reflexionsprozesse untersützen kann. Deshalb können Gespräche und einzelne Angebote auch draussen stattfinden.</p>

          <DottedLineHorizontal />

          <p>
          Die Natur bietet Bilder, Metaphern und Analogien an, die auf menschliche Erfahrungen und Lebenssituationen übertragen werden können. Durch Beobachtung können Zusammenhänge entdeckt, abstrahiert und für das eigene Leben fruchtbar gemacht werden.</p>

          <p>Im Jahreslauf verändern sich Landschaften und Pflanzen. Wachstum, Blüte, Reife, Rückzug und Neubeginn lassen sich in der Natur beobachten. Sie können als Bilder dienen, die helfen, eigene Erfahrungen, Übergänge und Entwicklungsprozesse zu betrachten und zu verstehen.</p>

          <p>Naturphänomene, Pflanzen oder Jahreszeiten können dabei Symbole und Bedeutungen anregen, die im Gespräch erkundet, vertieft und in einen persönlichen Zusammenhang gestellt werden.</p>
        </Text>
    </div>
  </DefaultLayout>

export default NaturUndIhreBedeutung